export interface PlanogramItem {
  id: string;
  sku: string;
  name: string;
  aisle: string;
  shelf: number;
  qtyExpected: number;
  qtyOnShelf: number;
  status: 'Compliant' | 'Unauthorized' | 'Low Stock';
}

export interface DiscontinuedItem {
  id: string;
  sku: string;
  name: string;
  category: string;
  qtyOnShelf: number;
  status: 'Pending' | 'Cleared';
  dateAdded: string;
}

export const mockPlanogram: PlanogramItem[] = [
  {
    id: '1',
    sku: 'SKU001',
    name: 'Coca-Cola 2L Bottle',
    aisle: 'Beverages',
    shelf: 3,
    qtyExpected: 24,
    qtyOnShelf: 22,
    status: 'Compliant',
  },
  {
    id: '2',
    sku: 'SKU002',
    name: 'Sprite 6-Pack',
    aisle: 'Beverages',
    shelf: 2,
    qtyExpected: 18,
    qtyOnShelf: 16,
    status: 'Compliant',
  },
  {
    id: '3',
    sku: 'SKU003',
    name: 'Mountain Dew Unauthorized Brand',
    aisle: 'Beverages',
    shelf: 2,
    qtyExpected: 0,
    qtyOnShelf: 8,
    status: 'Unauthorized',
  },
  {
    id: '4',
    sku: 'SKU004',
    name: 'Tropicana Orange Juice 64oz',
    aisle: 'Juices',
    shelf: 1,
    qtyExpected: 12,
    qtyOnShelf: 8,
    status: 'Low Stock',
  },
  {
    id: '5',
    sku: 'SKU005',
    name: 'Minute Maid Apple Juice',
    aisle: 'Juices',
    shelf: 1,
    qtyExpected: 15,
    qtyOnShelf: 14,
    status: 'Compliant',
  },
  {
    id: '6',
    sku: 'SKU006',
    name: 'Store Brand Cola (Unauthorized)',
    aisle: 'Beverages',
    shelf: 3,
    qtyExpected: 0,
    qtyOnShelf: 12,
    status: 'Unauthorized',
  },
  {
    id: '7',
    sku: 'SKU007',
    name: 'Fanta Orange',
    aisle: 'Beverages',
    shelf: 2,
    qtyExpected: 20,
    qtyOnShelf: 20,
    status: 'Compliant',
  },
  {
    id: '8',
    sku: 'SKU008',
    name: 'Dasani Water 24-Pack',
    aisle: 'Water',
    shelf: 4,
    qtyExpected: 30,
    qtyOnShelf: 28,
    status: 'Compliant',
  },
];

export const mockDiscontinued: DiscontinuedItem[] = [
  {
    id: 'd1',
    sku: 'SKU009',
    name: 'Old Brand Soda 2L',
    category: 'Beverages',
    qtyOnShelf: 5,
    status: 'Pending',
    dateAdded: '2026-04-10',
  },
  {
    id: 'd2',
    sku: 'SKU010',
    name: 'Vintage Juice Brand',
    category: 'Juices',
    qtyOnShelf: 3,
    status: 'Pending',
    dateAdded: '2026-04-12',
  },
  {
    id: 'd3',
    sku: 'SKU011',
    name: 'Legacy Water Bottles',
    category: 'Water',
    qtyOnShelf: 0,
    status: 'Cleared',
    dateAdded: '2026-04-01',
  },
];

export const mockAisles = ['Beverages', 'Juices', 'Water', 'Snacks', 'Dairy'];
